import type { OpenXmlPart } from './openXmlPart';
import { SharedStrings } from './sharedStrings';
import { SheetPart } from './sheetPart';
import { TablePart } from './tablePart';
import { WorkbookPart } from './workbookPart';

let partRegistry: Record<string, typeof OpenXmlPart> | null = null;

export function getPartRegistry(): Record<string, typeof OpenXmlPart> {
  if (!partRegistry) {
    partRegistry = {
      'http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings':
        SharedStrings,
      'http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet':
        SheetPart,
      'http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument':
        WorkbookPart,
      'http://schemas.openxmlformats.org/officeDocument/2006/relationships/table':
        TablePart,
    };
  }
  return partRegistry;
}

export function registerPartType(type: string, part: typeof OpenXmlPart) {
  getPartRegistry()[type] = part;
}

export function getPartType(type: string): typeof OpenXmlPart | undefined {
  return getPartRegistry()[type];
}
